import React from 'react';
import './PBackground.css';

// Fixed seed positions so they don't re-randomise on every render
const LETTERS = [
  { x:  4,  y:  6,  rot: -35, size: 7.2, op: 0.028 },
  { x: 18,  y: 22,  rot:  72, size: 5.1, op: 0.022 },
  { x: 33,  y:  3,  rot: -18, size: 9.0, op: 0.018 },
  { x: 48,  y: 14,  rot:  55, size: 6.4, op: 0.030 },
  { x: 62,  y:  8,  rot: -80, size: 4.8, op: 0.020 },
  { x: 76,  y: 19,  rot:  30, size: 8.3, op: 0.025 },
  { x: 89,  y:  5,  rot: -52, size: 5.6, op: 0.022 },
  { x:  9,  y: 38,  rot:  65, size: 7.8, op: 0.018 },
  { x: 24,  y: 44,  rot: -25, size: 5.2, op: 0.028 },
  { x: 41,  y: 31,  rot:  88, size: 9.5, op: 0.016 },
  { x: 56,  y: 42,  rot: -60, size: 6.0, op: 0.024 },
  { x: 70,  y: 35,  rot:  15, size: 4.5, op: 0.030 },
  { x: 84,  y: 48,  rot: -42, size: 7.1, op: 0.020 },
  { x:  2,  y: 62,  rot:  78, size: 5.8, op: 0.026 },
  { x: 15,  y: 70,  rot: -10, size: 8.6, op: 0.018 },
  { x: 30,  y: 58,  rot:  48, size: 6.2, op: 0.022 },
  { x: 46,  y: 66,  rot: -70, size: 9.8, op: 0.015 },
  { x: 60,  y: 74,  rot:  22, size: 5.4, op: 0.028 },
  { x: 75,  y: 60,  rot: -33, size: 7.5, op: 0.020 },
  { x: 91,  y: 68,  rot:  62, size: 4.9, op: 0.025 },
  { x:  7,  y: 85,  rot: -55, size: 6.7, op: 0.022 },
  { x: 22,  y: 88,  rot:  40, size: 8.1, op: 0.018 },
  { x: 38,  y: 80,  rot: -20, size: 5.0, op: 0.030 },
  { x: 53,  y: 90,  rot:  75, size: 7.3, op: 0.020 },
  { x: 67,  y: 83,  rot: -45, size: 9.2, op: 0.016 },
  { x: 82,  y: 92,  rot:  10, size: 5.5, op: 0.026 },
  { x: 95,  y: 78,  rot: -68, size: 6.9, op: 0.022 },
  { x: 12,  y: 96,  rot:  55, size: 4.6, op: 0.028 },
  { x: 44,  y: 97,  rot: -30, size: 8.4, op: 0.018 },
  { x: 78,  y: 94,  rot:  20, size: 6.1, op: 0.024 },
];

export default function PBackground() {
  return (
    <div className="p-bg" aria-hidden="true">
      {LETTERS.map((l, i) => (
        <span
          key={i}
          className="p-bg__letter"
          style={{
            left:      `${l.x}%`,
            top:       `${l.y}%`,
            fontSize:  `${l.size}rem`,
            opacity:   l.op,
            transform: `rotate(${l.rot}deg)`,
          }}
        >
          p
        </span>
      ))}
    </div>
  );
}
